import { call, put, takeLatest } from 'redux-saga/effects';
import { ActionTypes } from '../constants';
import utils from '../utils';
import Api from '../api';
import patternSaga from './patternSaga';
import { getBlogById } from '../actions/blogsActions';

const blogsApiUrl = `${utils.config.apiUserUrl}/blogs`;

const fetchBlogsListSaga = {
  requestFunction: Api.Blogs.getBlogs,
  requestUrl: blogsApiUrl,
  onFailure: {
    notification: {
      type: 'error',
      notificationType: 'notification',
      staticNotification: true,
      className: 'ant-notification-error'
    }
  }
}

const fetchBlogByIdSaga = {
  requestFunction: Api.Blogs.getBlogById,
  requestUrl: blogsApiUrl,
  onFailure: {
    notification: {
      type: 'error',
      notificationType: 'notification',
      staticNotification: true,
      className: 'ant-notification-error'
    }
  }
};

const fetchBlogBySlugSaga = {
  requestFunction: Api.Blogs.getBlogBySlug,
  requestUrl: blogsApiUrl,
  onFailure: {
    notification: {
      type: 'error',
      notificationType: 'notification',
      staticNotification: true,
      className: 'ant-notification-error'
    }
  }
};

const createBlogSaga = {
  requestFunction: Api.Blogs.createBlog,
  requestUrl: blogsApiUrl,
  spinner: true,
  onSuccess: {
    notification: {
      staticNotification: true,
      data: { code: '101' }
    },
    trigAction: [],
    callback: () => {
      // Redirect to blogs list after creation.
      window.location.href = '/blogs';
    }
  },
  onFailure: {
    notification: {
      type: 'error',
      notificationType: 'notification',
      staticNotification: true,
      className: 'ant-notification-error'
    }
  }
};

const updateBlogSaga = {
  requestFunction: Api.Blogs.updateBlog,
  requestUrl: blogsApiUrl,
  spinner: true,
  onSuccess: {
    notification: {
      staticNotification: true,
      data: { code: '102' }
    },
    trigAction: [
      ({ id }) => getBlogById(id)
    ],
    callback: () => {
      // Redirect to blogs list after update.
      window.location.href = '/blogs';
    }
  },
  onFailure: {
    notification: {
      type: 'error',
      notificationType: 'notification',
      staticNotification: true,
      className: 'ant-notification-error'
    }
  }
};

const deleteBlogSaga = {
  requestFunction: Api.Blogs.deleteBlog,
  requestUrl: blogsApiUrl,
  onSuccess: {
    notification: {
      staticNotification: true,
      data: { code: '103' }
    },
    trigAction: [],
    callback: () => {
      // Redirect to blogs list after deletion
      window.location.href = '/blogs';
    }
  },
  onFailure: {
    notification: {
      type: 'error',
      notificationType: 'notification',
      staticNotification: true,
      className: 'ant-notification-error'
    }
  }
};

const searchBlogsSaga = {
  requestFunction: Api.Blogs.search,
  requestUrl: blogsApiUrl,
  onFailure: {
    notification: {
      type: 'error',
      notificationType: 'notification',
      staticNotification: true,
      className: 'ant-notification-error'
    }
  }
};

function callDispatchCallback(callback, payload) {
  if (!callback) {
    return;
  }

  if (Array.isArray(callback)) {
    callback.forEach((handler) => {
      if (typeof handler === 'function') {
        handler(payload);
      }
    });
    return;
  }

  if (typeof callback === 'function') {
    callback(payload);
  }
}

function* uploadBlogImageSaga(action) {
  const { requestConfig = {}, dispatchCallBack = {} } = action;
  const requestUrl = `${utils.config.apiFilesUrl}/users?type=${requestConfig.fileType || 'BLOG_IMAGE'}`;

  try {
    yield put({ type: ActionTypes.SHOW_SPINNER });
    yield put({ type: ActionTypes.UPLOAD_BLOG_IMAGE_REQUEST_STARTED });

    const {
      request: { status },
      response,
    } = yield call(Api.Blogs.uploadImage, requestUrl, requestConfig);

    if (status && (status === 200 || status === 201 || status === 204)) {
      yield put({
        type: ActionTypes.UPLOAD_BLOG_IMAGE_REQUEST_SUCCESS,
        payload: response || {},
      });
      callDispatchCallback(dispatchCallBack.onSuccess, response);
    } else {
      yield put({
        type: ActionTypes.UPLOAD_BLOG_IMAGE_REQUEST_FAILURE,
        payload: response || {},
      });
      callDispatchCallback(dispatchCallBack.onFailure, response);
    }
  } catch (error) {
    yield put({
      type: ActionTypes.UPLOAD_BLOG_IMAGE_REQUEST_FAILURE,
      payload: error,
    });
    callDispatchCallback(dispatchCallBack.onFailure, error);
  } finally {
    yield put({ type: ActionTypes.UPLOAD_BLOG_IMAGE_REQUEST_FINISHED });
    yield put({ type: ActionTypes.HIDE_SPINNER });
  }
}

export default function* watchBlogsSaga() {
  yield takeLatest(ActionTypes.GET_BLOGS_LIST_REQUEST, patternSaga, fetchBlogsListSaga);
  yield takeLatest(ActionTypes.GET_BLOG_BY_ID_REQUEST, patternSaga, fetchBlogByIdSaga);
  yield takeLatest(ActionTypes.GET_BLOG_BY_SLUG_REQUEST, patternSaga, fetchBlogBySlugSaga);
  yield takeLatest(ActionTypes.CREATE_BLOG_REQUEST, patternSaga, createBlogSaga);
  yield takeLatest(ActionTypes.UPDATE_BLOG_REQUEST, patternSaga, updateBlogSaga);
  yield takeLatest(ActionTypes.DELETE_BLOG_REQUEST, patternSaga, deleteBlogSaga);
  yield takeLatest(ActionTypes.SEARCH_BLOGS_REQUEST, patternSaga, searchBlogsSaga);
  yield takeLatest(ActionTypes.UPLOAD_BLOG_IMAGE_REQUEST, uploadBlogImageSaga);
}
